import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {Account, AccountType} from '../models/accounts/account.model';
import {Job} from '../models/pos/job.model';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AccountsService {

  constructor(private http: HttpClient) {
  }

  private ACCOUNTS_URL: string = environment.BASE_URL + 'account';

  public getAccounts(type: AccountType): Observable<Array<Account>> {
    return this.http.get<Array<Account>>(this.ACCOUNTS_URL, {
      params: {
        type
      }
    }).pipe(map(accounts => accounts.sort((a1, a2) => {
        return a1.name.localeCompare(a2.name);
      }))
    );
  }

  public getAccount(id: string): Observable<Account> {
    return this.http.get<Account>(`${this.ACCOUNTS_URL}/${id}`).pipe(
    );
  }

  public getAccountOrders(id: string): Observable<Job[]> {
    return this.http.get<Job[]>(`${this.ACCOUNTS_URL}/${id}/orders`).pipe();
  }

  public createAccount(account: Account): Observable<Account> {
    const createAccount = {
      ...account,
    };
    return this.http.post<Account>(`${this.ACCOUNTS_URL}`, createAccount).pipe(
    );
  }

  public updateAccount(account: Account): Observable<Account> {
    const {id} = account;
    const patch = {
      ...account,
      userId: account.user ? account.user.id : null,
    };
    delete patch.id;
    return this.http.patch<Account>(`${this.ACCOUNTS_URL}/${id}`, patch).pipe(
    );
  }

  public deleteAccount(account: Account): Observable<Account> {
    return this.http.delete<Account>(`${this.ACCOUNTS_URL}/${account.id}`).pipe(
    );
  }
}
